module.exports = __webpack_public_path__ + "img/service-icon-1.98d00885.png";